const VIRTUALTOUR_PROVIDERS: Record<string, string>[] = [
  {
    regexpattern: '.*(realit|tour).virtual-view.ch/(.*)',
    url: 'https://$1.virtual-view.ch/$2',
  },
  {
    regexpattern: '.*my.matterport.com/show/?(.*)',
    url: 'https://my.matterport.com/show/$1',
  },
  {
    regexpattern: '.*3dprojekt.ch/(.*)',
    url: 'https://3dprojekt.ch/$1',
  },
  {
    regexpattern: '.*app.immoviewer.com/portal/tour/(.*)',
    url: 'https://app.immoviewer.com/portal/tour/$1',
  },
  {
    regexpattern: '.*theta360\\.com\\/(s|spheres\\/samples)\\/(.*)',
    url: 'https://theta360.com/$1/$2',
  },
  {
    regexpattern: '.*pano\\.casageno\\.ch\\/(\\w*\\.\\d*)\\/(\\w*\\.\\d*)\\.html',
    url: 'https://pano.casageno.ch/$1/$2.html',
  },
  {
    regexpattern: '.*immoscan24\\.ch\\/project\\/([\\w\\d-]*)\\/',
    url: 'https://immoscan24.ch/project/$1/',
  },
  {
    regexpattern: '.*www.mantamotion.com/3d-model/([^/]*)/(.*)',
    url: 'https://www.mantamotion.com/3d-model/$1/fullscreen/?embedded',
  },
  {
    regexpattern: '.*ogulo.de/tour/(.*)',
    url: 'https://ogulo.de/tour/$1',
  },
  {
    regexpattern: '.*filmzeit\\.bplaced\\.net\\/(.*)\\/(.*)\\/index.html',
    url: 'https://filmzeit.bplaced.net/$1/$2/index.html',
  },
  {
    regexpattern: '.*3d-grundrisse\\.ch\\/360Grad\\/(.*)\\/vtour',
    url: 'https://3d-grundrisse.ch/360Grad/$1/vtour',
  },
  {
    regexpattern: '.*tour.realforce.ch/p/REALFORCEAG/(.*)',
    url: 'https://tour.realforce.ch/p/REALFORCEAG/$1',
  },
  {
    regexpattern: '.*downloads.eye-worx.photo/360/([A-Z0-9]+)/.*',
    url: 'http://downloads.eye-worx.photo/360/$1/index.html',
  },
  {
    regexpattern: '.*homegate.designraum.ch/(.*)',
    url: 'http://homegate.designraum.ch/$1',
  },
  {
    regexpattern: '.*view.housetube.ch/?\\?.*project-id=(\\d*).*',
    url: 'https://view.housetube.ch?project-id=$1',
  },
  {
    regexpattern: '.*www.360magictour.com/projects/\\?project=([0-9a-f\\-]+).*',
    url: 'https://www.360magictour.com/projects/?project=$1',
  },
  {
    regexpattern:
      '.*spaces.archilogic.com/([^/]+)/([^/]+)/([^/]+)/?\\?.*modelResourceId=([0-9a-f\\-]+).*',
    url: 'https://spaces.archilogic.com/3d/$2/$3?modelResourceId=$4&mode=view&autostart=true&view-menu=none&main-menu=interior&presentation=once',
  },
  {
    regexpattern: '.*casatour.ch/(.*)/id/([A-Z0-9]+).*',
    url: 'https://360.casatour.ch/view/fullscreen/id/$2',
  },
  {
    regexpattern: '.*spectando.com/tour([A-Za-z0-9]+).*',
    url: 'https://spectando.com/tour$1',
  },
  {
    regexpattern: '.*virtual.immosky.ch/([\\d]+)/.*',
    url: 'https://virtual.immosky.ch/$1/',
  },
  {
    regexpattern: '.*tour.immovisual.ch/(.*)',
    url: 'https://tour.immovisual.ch/$1',
  },
  {
    regexpattern: '.*360-grad-rundgang.ch/(.*)',
    url: 'https://www.360-grad-rundgang.ch/$1',
  },
  {
    regexpattern: '.*tour.yetivisite.ch/([a-zA-Z0-9]+).*',
    url: 'https://tour.yetivisite.ch/$1',
  },
  {
    regexpattern: '.*pixroom.ch/vr/(.*)',
    url: 'https://pixroom.ch/vr/$1',
  },
  {
    regexpattern: '.*immo-fosgograf.ch/panoramen/(.*)',
    url: 'https://www.immo-fosgograf.ch/panoramen/$1',
  },
  {
    regexpattern: '.*tour.saner-im.ch/(.*)',
    url: 'https://tour.saner-im.ch/$1',
  },
  {
    regexpattern: '.*roundme.com/embed/(.*)',
    url: 'https://roundme.com/embed/$1',
  },
  {
    regexpattern: '(.*swissinteractive.ch)/(panorama|media)/(.*)',
    url: '$1/$2/$3',
  },
  {
    regexpattern: '(http://|https://)(3d|360)\\.(.*)',
    url: 'https://$2.$3',
  },
  {
    regexpattern: '.*(panos|reloc)\\.eifachbesser\\.ch/(.*)',
    url: 'https://$1.eifachbesser.ch/$2',
  },
  {
    regexpattern: '.*inav.begehungen.de/tour.php(.*)',
    url: 'https://inav.begehungen.de/tour.php$1',
  },
  {
    regexpattern: '.*markstein.immobilienrundgang.ch/360/(.*)',
    url: 'https://markstein.immobilienrundgang.ch/360/$1',
  },
  {
    regexpattern: '.*(tour|www)\\.klapty\\.com\\/(tour\\/)?(.*)',
    url: 'https://tour.klapty.com/$3',
  },
  {
    regexpattern: '.*tour.immobilien360.ch/(.*)',
    url: 'https://tour.immobilien360.ch/$1',
  },
];

export enum HgListingVirtualTourTypes {
  VIRTUAL_TOUR,
  ARCHILOGIC,
}

export const isVirtualTourUrl = (url: string): boolean => {
  return VIRTUALTOUR_PROVIDERS.some((provider) => {
    const regexpattern = new RegExp(provider.regexpattern);
    return regexpattern.test(url);
  });
};

export const getVirtualTourUrl = (url: string): string | undefined => {
  if (!isVirtualTourUrl(url)) {
    return;
  }

  const currentProvider = VIRTUALTOUR_PROVIDERS.find((provider) => {
    const regexpattern = new RegExp(provider.regexpattern);
    return regexpattern.test(url);
  });

  const matchRegex = new RegExp(currentProvider!.regexpattern);
  return url.replace(matchRegex, currentProvider!.url);
};

interface HgListingVirtualTour {
  src?: string;
  label?: string;
  title?: string;
}

export type { HgListingVirtualTour };
